// extracted by mini-css-extract-plugin
module.exports = {"ldsDefault":"Loader_ldsDefault__3k4G5"};